// src/components/_shared/links.js

export function ensureHttp(url = '') {
  let u = String(url || '').trim()
  if (!u) return ''
  if (!/^https?:\/\//i.test(u)) u = 'https://' + u
  return u
}

export function urlSolscanToken(mint) {
  const m = String(mint || '').trim()
  return m ? `https://solscan.io/token/${m}` : '#'
}

export function urlSolscanTx(hash) {
  const h = String(hash || '').trim()
  return h ? `https://solscan.io/tx/${h}` : '#'
}

export function urlGmgnToken(mint) {
  const m = String(mint || '').trim()
  return m ? `https://gmgn.ai/sol/token/${m}` : '#'
}

// aliases (backward-friendly names)
export const solscanLink  = urlSolscanToken
export const solscanTxUrl = urlSolscanTx
export const gmgnLink     = urlGmgnToken
